var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 90.5 95",
    style: {
      enableBackground: "new 0 0 90.5 95"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#4D121A;}\r\n\t.st1{fill:#BC1F36;}\r\n\t.st2{fill:#FCE8F1;}\r\n\t.st3{fill:#E12848;}\r\n\t.st4{opacity:0.3;fill:#FFFFFF;}\r\n\t.st5{opacity:0.8;fill:#FDFEFE;}\r\n\t.st6{opacity:0.8;fill:#FFFFFF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 45.3,
    cy: 49.8,
    r: 45.3
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 45.3,
    cy: 47.3,
    r: 45.3
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 45.3,
    cy: 45.3,
    r: 45.3
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 45.3,
    cy: 45.3,
    r: 42.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M87.7,45.3c0,23.5-19,42.5-42.5,42.5S2.8,68.7,2.8,45.3c2.8,44,45.3,40.9,62,31.2 C85.1,64.8,86.8,54.1,87.7,45.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M6.1,61.8C-3,40.2,7.2,15.3,28.8,6.1s46.5,1,55.6,22.7C64.8-10.6,25.2,6.7,13.5,22 C-0.7,40.7,3.6,53.3,6.1,61.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M30.3,11.6c0,0-4.3-2.9-7.9-0.7s-4.1,5.5-3.4,7.4c0.7,1.7,2.3,1.6,3.8-1.2s5.2-3,5.2-3S31.7,14.3,30.3,11.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M15.8,20.7l0.6-0.9c0.3-0.4,1.1-0.7,1.6-0.4h0c0.5,0.4,0.5,1.2,0.3,1.6l-0.6,0.9c-0.3,0.4-1.1,0.8-1.6,0.4 l0,0C15.6,22,15.6,21.1,15.8,20.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M61,79.2l4.7-1.9c1.1-0.5,2.3-0.1,2.7,0.9l0,0c0.4,1-0.2,2.1-1.3,2.6l-4.7,1.9c-1.1,0.5-2.3,0.1-2.7-0.9l0,0 C59.3,80.8,59.9,79.7,61,79.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M69.6,76.5l0.6-0.3c0.3-0.1,0.9,0,1,0.4l0,0c0.2,0.4-0.1,0.8-0.4,0.9l-0.6,0.3c-0.3,0.1-0.9,0-1-0.3l0,0 C69.1,77.1,69.4,76.6,69.6,76.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M31.7,25.6l35.5,35.5c1.5,1.5,1.5,4,0,5.6l-2.8,2.8c-1.5,1.5-4,1.5-5.6,0L23.3,34c-1.5-1.5-1.5-4,0-5.6 l2.8-2.8C27.7,24,30.2,24,31.7,25.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M67.2,34L31.7,69.4c-1.5,1.5-4,1.5-5.6,0l-2.8-2.8c-1.5-1.5-1.5-4,0-5.6l35.5-35.5c1.5-1.5,4-1.5,5.6,0 l2.8,2.8C68.7,29.9,68.7,32.4,67.2,34z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcon);
export default __webpack_public_path__ + "static/media/close-icon.5cf9dd7549dafe307bf1a19993666edd.svg";
export { ForwardRef as ReactComponent };